module.exports = __webpack_public_path__ + "img/face-bg.9fee8494.png";